var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-btn',{staticClass:"go-back-button",attrs:{"color":"white","top":"","icon":"","left":""},on:{"click":_vm.goBack}},[_c('v-icon',[_vm._v("mdi-arrow-left")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }